export default function isInViewport($element) {
	if (!$element) {
		return false;
	}
	const rect = $element.getBoundingClientRect();
	return rect.top < window.innerHeight && rect.bottom > 0;
}